import _styled from "styled-components";
import React from "react";
import { m } from "framer-motion";
import { debounce } from "~/features/app/utils";
import { type Mode } from "~/features/ui/get-theme-style";
import { useChipEvolutionGraphBlock } from "~/features/blocks/inventory/chip-evolution-graph/context";
type ViewProps = {
  containerRef: React.RefObject<HTMLDivElement | null>;
  startId: string;
  endId: string;
  animate: boolean;
  index: number;
  mode: Mode;
};
type Props = Omit<ViewProps, "mode">;
export function GraphLineView(props: ViewProps) {
  const {
    containerRef,
    startId,
    endId,
    animate,
    index,
    mode
  } = props;
  const [lineCoords, setLineCoords] = React.useState({
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
  });
  const [viewBox, setViewBox] = React.useState("0 0 0 0");
  const [size, setSize] = React.useState({
    width: 0,
    height: 0
  });
  React.useEffect(() => {
    if (!containerRef.current) {
      return;
    }
    function onResize() {
      if (!containerRef.current) {
        return;
      }
      setViewBox(`0 0 ${containerRef.current?.scrollWidth} ${containerRef.current?.clientHeight}`);
      setSize({
        width: containerRef.current?.scrollWidth,
        height: containerRef.current?.clientHeight
      });
      const containerRect = containerRef.current.getBoundingClientRect();
      const startRect = containerRef.current.querySelector(startId)?.getBoundingClientRect();
      const endRect = containerRef.current.querySelector(endId)?.getBoundingClientRect();
      if (!startRect || !endRect) {
        return;
      }
      const x1 = startRect.left + startRect.width / 2 - containerRect.left;
      const y1 = startRect.top + startRect.height / 2 - containerRect.top;
      const x2 = endRect.left + endRect.width / 2 - containerRect.left;
      const y2 = endRect.top + endRect.height / 2 - containerRect.top;
      setLineCoords({
        x1,
        y1,
        x2,
        y2
      });
    }
    const debouncedOnResize = debounce(onResize);
    onResize();
    window.addEventListener("resize", debouncedOnResize);
    return () => {
      window.removeEventListener("resize", debouncedOnResize);
    };
  }, [containerRef, startId, endId]);
  return <m.div initial={{
    opacity: 0
  }} animate={{
    opacity: animate ? 1 : 0
  }} transition={{
    delay: index * 0.1
  }}>
      <_StyledSvg viewBox={viewBox} style={{
      width: size.width,
      height: size.height
    }}>
        <line {...lineCoords} stroke={mode === "dark" ? "white" : "black"} />
      </_StyledSvg>
    </m.div>;
}
export function GraphLine(props: Props) {
  const {
    mode
  } = useChipEvolutionGraphBlock();
  return <GraphLineView {...props} mode={mode} />;
}
var _StyledSvg = /*#__PURE__*/_styled("svg").withConfig({
  displayName: "graph-line___StyledSvg",
  componentId: "sc-78idzg-0"
})({
  "pointerEvents": "none",
  "position": "absolute",
  "inset": "0"
});